module.exports = __webpack_public_path__ + "img/karamoja3.84acb125.jpg";